export default {
  w4d: "4D",
  coming_soon: "Coming Soon...",
  virtual_games: "Virtual",
  support: "Contact Us",
  bet_limit: "Bet Limit",
  favorites: "Favourites",
  note: "Note",
  my_bets: "My Bets",
  my_account: "My Account",
  contact_us: "Contact Us",
  report: "Report",
  help_support: "Help & Support",
  currency: "Currency",
  others: "Others",
  welcome: "Welcome",
  account_id: "Account ID",
  password: "Password",
  account: "Account",
  all_sports: "All Sports",
  my_sports: "Sports",
  action: "Action",
  accept_better_odds: "Accept Better Odds",
  accept_any_odds: "Accept Any Odds",
  auto_refresh_odds: "Auto Refresh Odds",
  auto_refresh: "Auto Refresh",
  auto_refreshing: "Auto Refreshing...",
  all_markets: "All Markets",
  away: "Away",
  all: "All",
  accepted: "Accepted",
  add_to_parlay: "Add To Parlay",
  add_to_booster: "Add To Booster",
  amount: "Amount",
  amount_before_balance: "Amount Before Balance",
  amount_after_balance: "Amount After Balance",
  bet_slip: "Bet Slip",
  bet_credit: "Bet Credit",
  bet_list: "Bet List",
  betting: "Betting",
  balance: "Balance",
  betting_statement: "Betting Statement",
  bet_types: "Bet Types",
  bet_type: "Bet Type",
  bs: "B/S",
  bet_summary: "Bet Summary",
  bet_reject: "Void Bet",
  bets: "Bets",
  bet: "Bet",
  booster: "Boost",
  casino: "Casino",
  mini_casino: "Mini Casino",
  cash_balance: "Cash Balance",
  change_account_password: "Change Account Password",
  current_password: "Current Password",
  confirm_new_password: "Confirm New Password",
  customize_sports_order: "Customize Sports Order",
  choice: "Choice",
  credit: "Credit",
  commission: "Commission",
  customize: "Customize",
  cancel: "Cancel",
  confirmation: "Confirmation",
  closing_balance: "Closing Balance",
  clear_filter: "Clear Filter",
  debit: "Debit",
  display_language: "Display Language",
  default_event_sorting: "Default Event Sorting",
  default_stake: "Default Stake",
  date: "Date",
  draw: "Draw",
  draw_cancel: "Draw",
  dec: "DEC",
  double_line: "Double Line",
  disable: "Disable",
  dec_odds: "Decimal Odds",
  id_odds: "Indo Odds",
  double_chance: "Double Chance",
  enable: "Enable",
  event_sorting: "Event Sorting",
  e_sports: "E-Sports",
  edit: "Edit",
  early: "Early",
  event: "Event",
  even: "Even",
  first_goal: "First Goal",
  first_half: "First Half",
  final: "Final",
  full_time: "Full Time",
  fold: "Fold",
  first_5_inn: "First 5 Innings",
  games: "Games",
  given_credit: "Given Credit",
  group: "Group",
  goal: "Goal",
  half_time: "Half Time",
  hide_header: "Hide Header",
  hk: "HK",
  hk_odds: "Hong Kong Odds",
  home: "Home",
  id: "ID",
  inactive: "Inactive",
  inplay: "In-Play",
  keno: "Keno",
  kickoff: "Kickoff",
  lottery: "Lottery",
  login: "Login",
  logout: "Logout",
  last_login: "Last Login",
  last_transaction: "Last Transaction",
  live_streaming: "Live TV",
  live_tv: "Live TV",
  live_match: "Live Match",
  live: "Live",
  live_center: "Live Center",
  livecasino: "Live Casino",
  loss: "Loss",
  lost: "Lost",
  lose: "Lose",
  lose_all: "Lose All",
  lose_half: "Lose Half",
  last_bet: "Last Bet",
  last_goal: "Last Goal",
  mobile: "Mobile",
  message: "Message",
  my_bet: "My Bet",
  my_favorites: "My Favourites",
  market_type: "Market Type",
  match: "Match",
  message_history: "Message History",
  my: "MY",
  market: "Market",
  main_markets: "Main Markets",
  my_odds: "Malay Odds",
  min: "Min",
  max: "Max",
  max_payout: "Max Payout",
  main: "Main",
  corners: "Corners/Booking",
  specials: "Specials",
  mix_parlay: "Mix Parlay",
  moneyline: "Moneyline",
  no_goal: "No Goal",
  normal_announcements: "Normal Announcements",
  nickname: "Nickname",
  new_password: "New Password",
  new: "New",
  "no/": "No.",
  normal_sorting: "Normal Sorting",
  other_markets: "Other Markets",
  outstanding: "Outstanding",
  odds_type: "Odds Type",
  odds: "Odds",
  opening_balance: "Opening Balance",
  outright: "Outright",
  on: "ON",
  off: "OFF",
  outstanding_bet: "Outstanding Bet",
  over: "Over",
  odd: "Odd",
  hdp: "HDP",
  ou: "O/U",
  oe: "O/E",
  oxt: "1X2",
  ml: "ML",
  password_expiry: "Password Expiry",
  parlay: "Parlay",
  page_display: "Page Display",
  page_type: "Page Type",
  page_size: "Page Size",
  personal_message: "Personal Message",
  process_bet: "Place Bet",
  payout: "Payout",
  pending: "Pending",
  quick_bet: "Quick Bet",
  quick_bet_stake: "Quick Bet Stake",
  result: "Result",
  restore: "Restore",
  remark: "Remark",
  ref_no: "Ref No.",
  remove_from_parlay: "Remove Parlay",
  remove_from_booster: "Remove Booster",
  running: "Running",
  rules: "Rules",
  rules_regulations: "Rules & Regulations",
  sports: "Sports",
  show_balance: "Show Balance",
  statement: "Statement",
  settings: "Settings",
  search_team: "Search Team",
  show_header: "Show Header",
  submit: "Submit",
  set_nickname: "Set Nickname",
  single: "Single",
  save: "Save",
  show_score_map: "Show Score Map",
  stake: "Stake",
  status: "Status",
  sort: "Sort",
  sportsbook: "Sportsbook",
  sum: "SUM",
  special_announcements: "Special Announcements",
  subtotal: "Subtotal",
  single_line: "Single Line",
  sort_by_time: "Sort by Time",
  slots: "Slots",
  mini_slots: "Mini Slots",
  select_leagues: "Select Leagues",
  settled_amount: "Settled Amount",
  turnover: "Turnover",
  today: "Today",
  time: "Time",
  team: "Team",
  to: "To",
  trans_time: "Trans.Time",
  total: "Total",
  total_goal: "Total Goal",
  treble: "Treble",
  transaction_date: "Transaction Date",
  transfer_method: "Transfer Method",
  transfer: "Transfer",
  under: "Under",
  void: "Void",
  reject: "Reject",
  rejected: "Reject",
  valid_turnover: "Valid Turnover",
  win: "Win",
  won: "Won",
  won_all: "Won All",
  won_half: "Won Half",
  waiting: "Waiting",
  yes: "Yes",
  no: "No",
  yesterday: "Yesterday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  all_league: "All",
  match_completed: "Completed",
  match_pending: "Result Pending",
  match_cancelled: "Refund",
  match_cancelled_1h: "Refund 1H",
  match_cancelled_2h: "Refund 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",
  check_all: "Check All",
  selected_only: "Selected Only",
  filtered: "Filtered",
  turn_on: "ON",
  turn_off: "OFF",
  preference: "My Preferences",
  market_1: "Early",
  market_2: "Today",
  market_3: "In-Play",
  american_football: "American Football",
  soccer: "Soccer",
  basketball: "Basktetball",
  baseball: "Baseball",
  esports: "E-Sports",
  esports2: "E-Sports",
  tennis: "Tennis",
  manila_suite: "Game Play",
  bangkok_suite: "SA Gaming",
  vegas_suite: "Evolution",
  vietnam_suite: "CT855",
  phnom_penh_suite: "Pretty Gaming",
  london_suite: "Pragmatic",
  yeebet_suite: "Yeebet",
  events: "Events",
  brackets: "Brackets",
  standing: "Standing",
  euro2020: "Euro 2020 Table",
  play_now: "Play Now",
  processing: "Processing...",
  big_small: "Big/Small",
  odd_even: "Odd/Even",
  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  official_link: "Official Link",
  virtual_sports: "Virtual Sports",
  virtual_soccer: "Virtual Soccer",
  virtual_horse_racing: "Virtual Horse Racing",
  virtual_dog_racing: "Virtual Dog Racing",
  virtual_motorsport: "Virtual Motorsport",
  prize1: "1ST PRIZE",
  prize2: "2ND PRIZE",
  prize3: "3RD PRIZE",
  round1: "ROUND 1",
  round2: "ROUND 2",
  round3: "ROUND 3",
  round4: "ROUND 4",
  round5: "ROUND 5",
  map1: "MAP 1",
  map2: "MAP 2",
  map3: "MAP 3",
  map4: "MAP 4",
  map5: "MAP 5",
  map6: "MAP 6",
  map7: "MAP 7",
  map8: "MAP 8",
  map9: "MAP 9",
  map10: "MAP 10",
  ftmode0: "All",
  ftmode9: "Next 2 Hours",
  ftmode1: "Next 4 Hours",
  ftmode2: "Next 8 Hours",
  ftmode3: "Now ~ 00:00",
  ftmode4: "00:00 ~ 04:00",
  ftmode5: "04:00 ~ 12:00",
  continue: "Continue",
  highlight: "Highlights",
  show_all_time: "Show All Time",
  back: "Back",
  fishing: "Fishing",
  upnext: "Up next",
  no_video: "No Video",
  mm_odds: "Myanmar Odds",
  mmo_parlay: "Myanmar Parlay",
  myanmar: "Myanmar",
  slashfruit: "Slash Fruit",
  happyfish: "Happy Fish",
  legendofphoenix: "Legend Of Phoenix",
  themonkeyking2: "The Monkey King 2",
  fishingwar: "Fishing War",
  goddefense: "God Defense",
  mini_games: "Mini Games",
  combo: "Combo",
  total_bet: "Total Bets",
  total_stake: "Total Stake",
  sysparlay: "System Parlay",
  total_match: "Total Matches",
  combination: "Combination",
  stakeperbet: "Stake Per Bet",
  total_payout: "Max Payout",
  total_accept: "Total Accepted",
  total_reject: "Total Rejected",
  sum_wl: "Total Win/Lose",
  sum_bet: "Total Stake",
  abets: " Bets",
  afold: " Fold",
  special_events: "Special Events",
  event_euro: "EURO 2024",
  event_copa: "COPA AMERICA 2024",
  event_olympic: "OLYMPIC 2024",
  event_worldcup: "WORLD CUP 2022",
  mini_arcade: "Mini Arcade",
  abandoned: "Abandoned",
  score: "Score",
  winner: "Winner",
  upcoming: "Upcoming",
  ko: "K.O By",
  live22: "Live22",
  pgs: "PGSoft",
  pragmatic: "Pragmatic",
  joker: "Joker",
  lucky_pick: "Parlay Generator",
  random_pick: "Generate",
  add_pick: "Add To Bet Slip",
  vgames: "V-Games",
  tournament: "Tournament",
  tournament2: "Tournament+",
  create_room: "Create Room",
  create_private_room: "Create Private Room",
  search_room: "Search Room",
  join_now: "Join Now",
  entry_fee: "Entry Fee",
  pool: "Payout $",
  room: "Room",
  matches: "matches",
  private: "Private",
  public: "Public",
  select_matches: "Select Matches",
  selected: "Selected",
  tomorrow: "Tomorrow",
  room_rate: "Room Rate",
  room_limit: "Room Limit",
  room_password: "PIN",
  join_room: "Join Room",
  enter_room: "Enter Room",
  leave_room: "Leave Room",
  joined_only: "Joined Only",
  last_betting_time: "Last Betting Time",
  owner: "Owner",
  room_id: "Room ID",
  points: "Points",
  total_points: "Total Points",
  refresh: "Refresh",
  details: "Details",
  bet_id: "Bet ID",
  room_status: "Room Status",
  winner_rank: "Winner Rank",
  players: "Players",
  rank_show: "Rank",
  rank_hide: "Result",
  refund: "Refund",
  simpleplay: "Simple Play",
  player: "Player",
  place_bet: "Place Bet",
  feedback: "Feedback",
  free_room: "Play To Earn",
  match_started: "-",
  jili: "JILI",
  ranking: "Ranking",
  total_winning: "Total Winning",
  first_prize: "1st Prize",
  second_prize: "2nd Prize",
  third_prize: "3rd Prize",
  participants: "Participants",
  place: "Place",
  current_prize: "Current Points",
  next: "Next",
  last_join_time: "Last Join Time",
  tutorial: "Replay Tutorial",
  introduction: "Introduction",
  close: "Close",
  jackpot: "Jackpot",
  prize: "Prize",
  exclusive: "Exclusive",
  uusl: "UU Slots",
  nextspin: "NextSpin",
  dbhash: "DB Hash",
  dbpoker: "DB Poker",
  poker: "Poker",
  adjustment: "Adjustment",
  error: "Error",
  notice: "Notice",
  no1: "1<sup>st</sup> Place Winner",
  wow_gaming: "Wow Gaming",
  ai_casino: "AI Casino",
  round_id: "Round ID",
  hot: "Hot",
  red: "Red",
  blue: "Blue",
  yellow: "Yellow",
  first_ball: "1st Ball",
  best_5_balls: "Best 5 Balls",
  wf_gaming: "WF Gaming",
  view_all: "View All",
  epicwin: "EpicWin"
};
